import React, {useEffect, useContext} from 'react';
import ProjectContext from '../../context/projects/projectContext';
import Spinner from "../layout/spinner/Spinner";
import {NavLink} from "react-router-dom";
import imageUrlBuilder from '@sanity/image-url';
import sanityClient from "../../client";
import Swal from "sweetalert2";

const builder = imageUrlBuilder(sanityClient);
const urlFor = (source) => {
  return builder.image(source)
}

const Projects = (props) => {
  const projectContext = useContext(ProjectContext);

  const {getProjects, projects, loading, error, clearErrors} = projectContext;

  console.log(props)

  useEffect(() => {
    getProjects();
    if (document.getElementById('mobile-menu').classList.contains("flex")) {
      document.getElementById('mobile-menu').classList.replace("flex", "hidden");
    }
  }, [])

  useEffect(() => {
    if (error?.isNetworkError) {
      Swal.fire({
        icon: 'info',
        text: 'Network Error, pls check your internet connection'
      })
    }
  }, [error])

  return (
    <div className="font-sans">
      <div className="mx-4 md:mx-20 lg:mx-32 text-left my-4 md:my-16 lg:my-24 lg:w-7/12">
        <p className="text-xl md:text-2xl lg:text-4xl font-bold">
          HTML, CSS, JavaScript, TypeScript, Java, React, Node, MongoDB, MySQL, PostgreSQL
        </p>
        <br/>
        <p className="text-xl md:text-2xl lg:text-4xl font-bold">
          PWA's, WebSockets, Spring and SpringBoot, Express.
          Projects include web scrapers for a portal to save result as pdf and a moodle
          site to download course notes.
        </p>
      </div>
      <div>
        {loading ?
          (<div className="flex flex-row justify-center items-center h-60 w-screen">
            <Spinner/>
          </div>)
          :
          projects?.map((project, index) => (
            <div key={index} className={`w-full flex justify-center items-center`}>
              <NavLink exact to={`/project/${project?.name}`}>
                <div className="mx-4 md:mx-24 lg:mx-32 py-6">
                  <div className="flex lg:flex-row flex-col">
                    <div className="lg:w-4/12 lg:pr-8 lg:self-center">
                      <p className="text-4xl">{project?.name}</p>
                      <p className="text-lg my-3">{project?.description}</p>
                      {/*<NavLink exact to={`/project/${project.name}`}>*/}
                        <p className="text-lg text-blue-400 underline">Click to learn more</p>
                      {/*</NavLink>*/}
                    </div>
                    <div className="my-4 lg:my-0 lg:w-8/12 h-4/5">
                      <img src={urlFor(project?.previewImage?.asset._ref).url()} alt={project?.name} loading="lazy"/>
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default Projects;
